import { useId } from 'react'
import { Paper, Stack, Typography } from '@mui/material'
import { SettingsRowCardBody } from '@/components/Settings/SettingsRowCardBody'
import { settingsRowPaperClassName } from '@/components/Settings/settingsPaperGroup'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * @param {import('@/components/Settings/SettingsRowCard').default extends (p: infer P) => unknown ? P : never} props
 */
export function SettingsRowCardWithTitle({ title, label, caption, value, LabelIcon, groupPosition, paperClassName, kpiDescription }) {
  const headingId = useId()
  const paperCn = [settingsRowPaperClassName({ groupPosition, compactY: false }), paperClassName].filter(Boolean).join(' ')

  return (
    <Stack component="section" spacing={1.25} className={shared.settingsStackRoot} aria-labelledby={headingId}>
      <Typography id={headingId} component="h2" variant="subtitle1" fontWeight={600} color="text.primary" className={shared.settingsSectionHeading}>
        {title}
      </Typography>
      <Paper elevation={0} className={paperCn}>
        <SettingsRowCardBody value={value} label={label} caption={caption} LabelIcon={LabelIcon} kpiDescription={kpiDescription} />
      </Paper>
    </Stack>
  )
}
